const comTtl = (() => {
  const elsm = document.querySelectorAll('.js-com-ttl');
  if (elsm.length > 0) {


    for (let i = 0; i < elsm.length; i++) {

      let targets = elsm[i];
      let nodes = [...targets.childNodes];
      let spanWrapText = ""
      nodes.forEach((node) => {
        if (node.nodeType == 3) {//テキストの場合
          const text = node.textContent.replace(/\r?\n/g, '');//テキストから改行コード削除
          //spanで囲んで連結
          spanWrapText = spanWrapText + text.split('').reduce((acc, v) => {
            return acc + `<span>${v}</span>`
          }, "");
        } else {//テキスト以外
          //<br>などテキスト以外の要素をそのまま連結
          spanWrapText = spanWrapText + node.outerHTML
        }
      })
      targets.innerHTML = spanWrapText



      let span = elsm[i].querySelectorAll('span');

      gsap.set(span, {
        rotationY: '90deg',
        opacity: "0",
      });

      let to = gsap.to(span, {
        rotationY: '0deg',
        opacity: "1",
        duration: 1,
        ease: "none",
        scrollTrigger: {
          trigger: elsm[i],
          start: "0% 80%",
          // markers: true
        },
        stagger: 0.1,
      })


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          to.scrollTrigger.refresh()
          // console.log('comParallax refresh');
        });
      });
      observer.observe(target);

    }



  }
})();
export default comTtl;